// pdfjs-dist calls Promise.withResolvers (ES2024); Safari < 17.4 and
// Chrome < 119 lack it and the resume viewer died with a TypeError
// (Sentry DIRECTDENTAL-1ZH). Import this module BEFORE anything that pulls
// in pdfjs — module imports execute in order, so a dedicated first import
// is hoisting-proof.
if (typeof (Promise as any).withResolvers !== "function") {
  (Promise as any).withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
